/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Status_UploadedInputs */

const en_doc_status_uploaded = /** @type {(inputs: Doc_Status_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploaded`)
};

const pt_br2_doc_status_uploaded = /** @type {(inputs: Doc_Status_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

/**
* | output |
* | --- |
* | "Uploaded" |
*
* @param {Doc_Status_UploadedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_status_uploaded = /** @type {((inputs?: Doc_Status_UploadedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Status_UploadedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_status_uploaded(inputs)
	return pt_br2_doc_status_uploaded(inputs)
});